import React from 'react';

export default function SadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140"
      height="140"
      viewBox="0 0 88 88">
      <path
        d="M44 0C19.723 0 0 19.723 0 44s19.723 44 44 44 44-19.723 44-44S68.277 0 44 0zm0 4c22.113 0 40 17.887 40 40S66.113 84 44 84 4 66.113 4 44 21.887 4 44 4zM31 30c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm26 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zM44 55c-3.574 0-7.316 1.082-10.625 2.688-3.309 1.605-6.168 3.69-7.969 6.093-.355.418-.523.97-.465 1.516.063.547.344 1.043.786 1.375.437.332.996.469 1.539.375.543-.09 1.023-.402 1.328-.86 1.199-1.597 3.664-3.511 6.53-4.906 2.868-1.394 6.145-2.28 8.876-2.28 2.73 0 6.008.886 8.875 2.28 2.867 1.395 5.332 3.309 6.531 4.907.305.457.785.769 1.328.859.543.094 1.102-.043 1.54-.375.44-.332.722-.828.784-1.375.06-.547-.109-1.098-.464-1.516-1.801-2.402-4.66-4.488-7.97-6.093C51.317 56.081 47.575 55 44 55z"
        className="path-primary"
      />
    </svg>
  );
}
